export default {
    PAGE_TYPES : [
        { text: "All", value: "" },
        { text: "Individual", value: "S" },
        { text: "Team Leader", value: "T" },
        { text: "Team Member", value: "I" }
    ]
}